import React from "react";

function Logo() {
  return (
    <svg width="50px" height="80px" viewBox="0 0 168 209" version="1.1">
      <title>Logo</title>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Book_thick_generic">
          <path
            d="M0.4662204,197.113681 C-0.0547296,186.872261 14.5702444,173.377711 36.3793894,173.377711 L167.54725,173.377711 L167.2864,0.5783397 L36.3793804,0.5783397 C13.7415354,0.5783397 -1.1394246,15.1887747 0.6080274,25.5376407"
            id="use4150"
            fill="#000000"
          ></path>
          <path
            d="M21.6206314,40.2708637 C10.4068734,40.2708637 3.7459324,35.7538147 3.3056184,30.6996767 C2.3921494,20.2156957 15.3940884,6.6456437 37.2550044,7.0117237 L161.74197,7.0117237 L161.0659,9.6588427 L158.7444,10.9564497 L158.8107,13.2483167 L159.33345,15.8954367 L156.85645,17.4061607 L156.53135,20.1244337 L153.85866,21.3498567 L153.92486,23.6417227 L152.94766,25.7203017 L153.47041,28.3674207 L150.9934,29.8781447 L151.51615,32.5252647 L150.53895,34.6038427 L147.01856,35.9014497 L148.58459,38.7618577 L146.10758,40.2725827 L21.6206314,40.2708637 Z"
            id="path4246"
            stroke="#000000"
            strokeWidth="1.56523359"
            fill="#FFFFFF"
          ></path>
          <polygon
            id="use4268"
            stroke="#000000"
            strokeWidth="1.56523359"
            fill="#FFFFFF"
            points="161.74197 170.976371 160.96053 173.623491 158.74435 174.921101 158.81055 177.212971 159.3333 179.860091 156.8563 181.370811 156.5312 184.089081 153.85851 185.314511 153.92481 187.606371 152.94762 189.684951 153.47037 192.332071 150.99335 193.842791 151.5161 196.489911 150.53891 198.568491 147.01851 199.866101 148.58455 202.726511 146.10753 204.237231 146.10753 40.2725827 148.58455 38.7618577 147.01851 35.9014497 150.53891 34.6038427 151.5161 32.5252647 150.99335 29.8781447 153.21312 28.3440347 152.94762 25.7203017 153.92481 23.6417227 153.85851 21.3498567 156.5312 20.1244337 156.8563 17.4061607 159.3333 15.8954367 158.81055 13.2483167 158.74435 10.9564497 161.09095 9.6588427 161.74194 7.0117237"
          ></polygon>
          <path
            d="M19.9059824,208.421671 L151.07383,208.421671 L151.07383,35.6222947 L19.9059734,35.6222947 C7.5717074,35.5421097 1.6166884,31.1847187 0.6085524,25.5629997 L0.4644594,197.077501 C0.7593534,203.305921 6.6442694,208.340181 19.9059824,208.421671 Z"
            id="path4207"
            fill="#000000"
          ></path>
          <g
            id="g3360"
            transform="translate(82.335500, 10.329281)"
            fill="#000000"
          >
            <polygon
              id="path4276"
              points="76.62085 1.373079 76.40891 0.657695 44.22465 1.373079 76.40891 2.088463"
            ></polygon>
            <polygon
              id="use4280"
              points="74.19575 9.795184 73.71675 8.629074 0.9773 9.795184 73.71675 10.961294"
            ></polygon>
            <polygon
              id="use4282"
              points="70.82416 14.645142 70.72229 14.11552 55.25247 14.645142 70.72229 15.174764"
            ></polygon>
            <path
              d="M76.46569,5.421583 C76.46569,5.421583 75.58326,5.729621 75.58326,5.729621 C75.8774,21.322306 76.17155,36.914992 76.46569,52.50768 C76.46569,52.50768 77.34812,5.729621 77.34812,5.729621 C77.05398,5.626941 76.75983,5.524262 76.46569,5.421583 Z"
              id="path4300"
            ></path>
            <path
              d="M73.51105,9.564824 C73.1491,9.729805 72.78715,9.894787 72.4252,10.059768 C72.78715,35.113505 73.1491,60.16724 73.51105,85.22098 C73.51105,85.22098 74.5969,10.059768 74.5969,10.059768 C74.23495,9.894787 73.873,9.729805 73.51105,9.564824 Z"
              id="use4310"
            ></path>
            <polygon
              id="path3450"
              points="71.28304 14.139902 70.63904 14.292107 71.53839 36.929026 71.93036 14.285865 71.28304 14.139902"
            ></polygon>
          </g>
        </g>
        <text
          id="B"
          fontFamily="Hack-Regular, Hack"
          fontSize="100"
          fontWeight="normal"
          fill="#FFFFFF"
        >
          <tspan x="45" y="158">
            B
          </tspan>
        </text>
      </g>
    </svg>
  );
}

export default Logo;
